// extracted by mini-css-extract-plugin
export default {"recos":"N4-z","productCardOverride":"O4-z","rowHasBadge":"P4-z"};